import { render, staticRenderFns } from "./bnvtextarea.vue?vue&type=template&id=0004d498&"
import script from "./bnvtextarea.vue?vue&type=script&lang=js&"
export * from "./bnvtextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports